<template>
  <div class="footer">
    <div class="footer-warpper">
      <div class="left">
        <figure class="img-logo" />
        <div class="cad-content">
          <p class="cad-title">迷你CAD</p>
          <div class="phone-box">
            <svg-icon name="phone" class="phone"></svg-icon>
            <span>400-600-2063</span>
          </div>
          <p class="cad-time">时间：工作日9:00-18:00</p>
        </div>
      </div>

      <ul class="right">
        <li v-for="item in data" :key="item.title">
          <p class="li-title">{{ item.title }}</p>
          <a
            :href="i.url"
            v-for="i in item.list"
            :key="i.name"
            target="_blank"
            rel="noopener noreferrer"
            :title="i.name"
            >{{ i.name }}</a
          >
        </li>

        <li>
          <p class="li-title">联系方式</p>
          <p class="box-text">400-600-2063</p>
          <a
            href="javascript:void(0)"
            title="QQ在线客服"
            class="underline"
            rel="nofollow noopener noreferrer"
            @click="toQqServe"
            >QQ在线客服</a
          >
          <a :href="linkURL1 + '/contact.html'" title="联系我们" target="_blank">联系我们</a>
        </li>

        <li>
          <p class="li-title">迷你CAD公众号</p>
          <figure class="box-img"></figure>
          <p class="li-des">扫码关注</p>
          <p class="li-des">了解更多福利</p>
        </li>
      </ul>
    </div>
    <div class="line"></div>
    <div class="foot-info">
      <span class="foot-info-text">迷你CAD</span>
      <div class="foot-info-text info-line">|</div>
      <span class="foot-info-text">版权所有 开发者：上海晓材科技有限公司</span>
      <div class="foot-info-text info-line">|</div>
      <a
        class="foot-info-text"
        href="http://beian.miit.gov.cn/"
        target="_blank"
        title="备案号"
        rel="external nofollow noopener noreferrer"
        >沪公网安备44030502008583</a
      >
      <div class="foot-info-text info-line">|</div>
      <a class="foot-info-text" :href="linkURL1 + '/privacy.html'" target="_blank" title="隐私协议"
        >隐私政策</a
      >
      <div class="foot-info-text info-line">|</div>
      <a
        class="foot-info-text"
        :href="linkURL1 + '/permission.html'"
        target="_blank"
        title="应用权限"
        rel="external nofollow noopener noreferrer"
        >应用权限</a
      >
    </div>
  </div>
</template>

<script setup>
import globalfun from '@/assets/js/globalfun'
import tool from '@/assets/js/tool'
import { useMapState } from '@/assets/js/use_storemap'
// import { ref } from 'vue'

/* --- 全局变量 --- */
// vuex
const { linkURL1, baseURL, linkURL2 } = useMapState({
  linkURL1: state => state.realm.linkURL1,
  baseURL: state => state.realm.baseURL,
  linkURL2: state => state.realm.linkURL2
})

const data = [
  {
    title: '网站导航',
    list: [
      { name: '升级日志', url: linkURL1.value + '/updateLog.html' },
      { name: '私有云SDK', url: linkURL1.value + '/privatecloudsdk.html' },
      { name: '企业版', url: baseURL.value + '/company/home' },
      { name: '帮助中心', url: linkURL1.value + '/help.html' }
    ]
  },
  {
    title: '产品中心',
    list: [
      { name: 'CAD迷你看图', url: linkURL1.value + '/mini_view.html' },
      { name: 'CAD迷你画图', url: linkURL1.value + '/mini_draw.html' },
      { name: 'CAD迷你家装', url: linkURL1.value + '/microcadhome.html' },
      { name: '三维CAD看图', url: linkURL1.value + '/3dview.html' },
      { name: '迷你CAD网页版', url: linkURL2.value }
    ]
  },
  {
    title: '其他',
    list: [
      { name: '隐私协议', url: linkURL1.value + '/privacy.html' },
      { name: '服务协议', url: linkURL1.value + '/agreement.html' },
      { name: '许可协议', url: linkURL1.value + '/agreementuser.html' }
    ]
  }
]

/* --- 函数方法 --- */
const toQqServe = tool.throttle(function () {
  globalfun.customerService('kefu_cad')
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
@import '@/assets/scss/_make.scss';

.footer {
  width: 100%;
  background: #fff;
  .footer-warpper {
    margin: 0 auto;
    display: flex;
    @include responsive-style(
      (
        width: 1200px,
        height: 420px
      )
    );

    .left {
      display: flex;
      @include responsive-style(
        (
          width: 358px,
          padding: 56px 0px,
          border-right: 1px solid #ededed
        )
      );
      .img-logo {
        @include make-backgroundimage-custom(
          lg,
          (
            name: '@/assets/img/cad/footer-logo',
            extname: 'png',
            width: 100,
            height: 100,
            version: '1'
          )
        );
        @include make-backgroundimage-custom(
          xl,
          (
            name: '@/assets/img/cad/footer-logo-xl',
            extname: 'png',
            width: 120,
            height: 120,
            version: '1'
          )
        );
        @include make-backgroundimage-custom(
          mx,
          (
            name: '@/assets/img/cad/footer-logo-mx',
            extname: 'png',
            width: 200,
            height: 200,
            version: '1'
          )
        );
        @include responsive-style(
          (
            margin-right: 16px
          )
        );
      }
      .cad-content {
        .cad-title {
          color: #000;
          font-weight: 700;
          @include responsive-style(
            (
              font-size: 40px,
              line-height: 100px,
              margin-bottom: 6px
            )
          );
        }
        .phone-box {
          display: flex;
          align-items: center;
        }
        .phone {
          @include responsive-style(
            (
              width: 36px,
              height: 36px
            )
          );
        }
        span {
          color: #000;
          font-weight: 400;
          @include responsive-style(
            (
              font-size: 20px,
              line-height: 36px
            )
          );
        }
        .cad-time {
          color: #585a5c;
          font-weight: 400;

          @include responsive-style(
            (
              font-size: 14px,
              margin-top: 3px,
              margin-left: 5px
            )
          );
        }
      }
    }
    .right {
      flex: 1;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      @include responsive-style(
        (
          padding: 80px 0px 80px 80px
        )
      );

      li {
        .li-title {
          color: #0f0f0f;
          font-weight: 500;

          @include responsive-style(
            (
              font-size: 16px,
              line-height: 24px,
              margin-bottom: 24px
            )
          );
        }
        a,
        .box-text {
          color: #302e38;
          font-weight: 350;
          display: block;

          @include responsive-style(
            (
              font-size: 14px,
              margin-bottom: 16px
            )
          );
        }
        a {
          &:hover {
            color: $--themecolor;
          }
          &.underline {
            text-decoration: underline;
          }
        }
        .box-img {
          @include make-backgroundimage-custom(
            lg,
            (
              name: '@/assets/img/cad/wxcode',
              extname: 'png',
              width: 100,
              height: 100,
              version: '1'
            )
          );
          @include make-backgroundimage-custom(
            xl,
            (
              name: '@/assets/img/cad/wxcode-xl',
              extname: 'png',
              width: 120,
              height: 120,
              version: '1'
            )
          );
          @include make-backgroundimage-custom(
            mx,
            (
              name: '@/assets/img/cad/wxcode-mx',
              extname: 'png',
              width: 200,
              height: 200,
              version: '1'
            )
          );
          @include responsive-style(
            (
              margin-left: 7px
            )
          );
        }

        .li-des {
          color: rgba(0, 0, 0, 0.64);
          text-align: center;
          font-weight: 350;

          @include responsive-style(
            (
              font-size: 14px,
              line-height: 21px
            )
          );
        }
      }
    }
  }
  .line {
    width: 100%;

    background: #ededed;
    @include responsive-style(
      (
        height: 1px
      )
    );
  }

  .foot-info {
    text-align: center;
    margin: 0 auto;

    @include responsive-style(
      (
        padding: 14px
      )
    );
    .foot-info-text {
      color: #585a5c;
      font-weight: 350;
      display: inline-block;

      @include responsive-style(
        (
          font-size: 12px,
          line-height: 18px
        )
      );
    }

    .info-line {
      @include responsive-style(
        (
          margin: 0 9px
        )
      );
    }

    a:hover {
      color: #006fff;
    }
  }
}
</style>
